<template>
  <div>
     <CRUDList
        ref="crudList"
        :canAdd="false"
        :canEdit="true"
        :canSave="false"
        :showSelect="false"
        :showDialog="false"
        :removeHighlightOnDoubleClick="false"
        :displayTopPagination="false"
        :headers="headers"
        :baseCrudKey="baseCrudKey"
        :footerTotalDisplayColumnWise="footerTotalArray"
        :defaultSortBy="defaultSortBy"
        :loadingData="gridLoading.flag"
        :loadingText="gridLoading.text"
        tableWrapperDynamicClassname="taxroll-table-wrapper-two"
        tableDynamicHeight="250"
        @loadCRUDList="getPickLists"
        @onDoubleClicked="handleTaxRecordDoubleClick"
      >
      <template v-slot:addidtionalCrudFooter>
        <h4 class="input-text-size pt-3 pl-1">RECORD COUNT: {{ totalPickListrecords }}</h4>
      </template>
      </CRUDList>
      <CRUDDialog
        :baseCrudKey='baseCrudKeyTwo'
        :canSave="true"
        :dialogHeaderName="dialogHeaderName"
        dialogDynamicWidth='550'
        @upsertItem="handleComment"
      ><template v-slot:[`editedItem`]="{}">
        <AddCommentDialog :baseCrudKey="baseCrudKeyTwo" />
        </template>
      </CRUDDialog>
      <!-- dialog for address update -->
      <CRUDDialog
        :baseCrudKey='baseCrudKeyThree'
        :canSave="true"
        :onlyDialogHeaderName="dialogHeaderThree"
        dialogDynamicWidth='550'
        @upsertItem="handleAddressChage"
      ><template v-slot:[`editedItem`]="{}">
        <PickListAddressChangeDialog :baseCrudKey="baseCrudKeyThree" ref="addressChange" />
        </template>
      </CRUDDialog>
      <CRUDDialog v-if="isVisibleProp"
        :baseCrudKey='baseCrudKeyFour'
        :canSave="false"
        :dialogHeaderName="dialogHeaderPayment"
        @crudDialogEnter="upsertPayments"
      ><template v-slot:[`editedItem`]="{}">
        <paymentDialog :baseCrudKey="baseCrudKeyFour" />
        </template>
        <template v-slot:[`additionalActionsAfterSave`]="{}">
          <UploadFile
                class="mtgtrans uploadFile"
                text
                :bucketName="attachmentConstants.bucketName"
                :program="attachmentConstants.program"
                :parentObjectType="attachmentConstants.parentObjectType"
                :parentObjectId="getActiveTransID || 'n/a'"
                :itemIsSaved="!isNewItem"
              >
                <template v-slot:activator="{ activatorProps }">
                  <v-btn
                    :disabled="enableUploadFile"
                    class="input-text-size"
                    text
                    color="blue darken-1"
                    @contextmenu.prevent="imagesRightClick(activatorProps.rightClick)"
                    @click="imagesLeftClick(activatorProps.leftClick)"
                  >
                    {{ activatorProps.caption }}
                  </v-btn>
                </template>
              </UploadFile>

        <v-btn :class="`input-text-size`" text color="blue darken-1"
        @click="onUpsertCall(false)" :disabled="isSaveBlocked">Save</v-btn>
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        @click="onUpsertCall(true)" :disabled="isSaveBlocked">Save & print</v-btn>
        </template>
      </CRUDDialog>
      <CRUDDialog
        :baseCrudKey='comDialogCrudKey'
        :canSave="true"
        :canCancel="false"
        onlyDialogHeaderName="Create Comment for Owner Info changes"
        @upsertItem="handleCommentForAddressChange"
        dialogDynamicWidth='550'
      ><template v-slot:[`editedItem`]="{}">
         <CommentDialog :baseCrudKey="comDialogCrudKey"/>
        </template>
      </CRUDDialog>
      <CRUDDialog
      v-if="destroyOrReRenderAdjComp"
      :baseCrudKey='adjDialogCrudKey'
      :canSave="true"
      :canCancel="false"
      onlyDialogHeaderName="Creating Adjustment Record for Owner Info changes"
      @upsertItem="handleAdjUpdate"
      dialogDynamicWidth='400'
      ><template v-slot:[`editedItem`]="{}">
        <CreateAdjTaxDialog :baseCrudKey="adjDialogCrudKey"/>
        </template>
      </CRUDDialog>
      <CRUDDialog
        baseCrudKey='pickListEmailAddressDialog'
        :canSave="true"
        dialogHeaderName="Email Address or Phone to all records in Picklist"
        dialogDynamicWidth='400'
        @upsertItem="handleAddEmailAddress"
      ><template v-slot:[`editedItem`]="{}">
        <div>
        <v-row>
          <v-col cols="12" class="pt-2 pb-0">
            <v-text-field v-model="addEmailAddressOnly" class="input-text-size"
              label="Email Address" />
          </v-col>
           <v-col cols="12" class="pt-2 pb-0">
            <v-text-field v-model="addPhone" class="input-text-size"
              label="Phone Number" />
          </v-col>
        </v-row>
      </div>
      </template>
      </CRUDDialog>

      <!-- Tax record dialog: opens when a pick list row is double-clicked -->
      <CRUDDialog
        ref="taxRecordDialog"
        :baseCrudKey="taxRecordCrudKey"
        :canSave="false"
        :canCancel="false"
        :tabsList="tabsList"
        :dialogDynamicWidth="wideDialogWidth"
        :dialogDynamicHeight="wideDialogHeight"
      ><template v-slot:[`editedItem`]="{}">
        <TaxInquiryDialog
          v-if="isTaxRecordDialogVisible"
          :baseCrudKey="taxRecordCrudKey"
          :baseCrudKeyForFeeList="baseCrudKeyForFeeList"
          :feeListBasedInIds="feeListBasedInIds"
          :attachmentConstants="taxRecordAttachmentConstants"
          @upsertItem="upsertRecords"
        />
        </template>
        <template v-slot:[`additionalActionsAfterSave`]="{}">
          <v-btn class="input-text-size" text color="blue darken-1"
          v-if="!areTheyAreForms()" @click="upsertRecords(false)">Save</v-btn>
          <v-btn class="input-text-size" text color="blue darken-1"
          @click="closeTaxRecordDialog">{{ !areTheyAreForms() ? 'Cancel' : 'Close' }}</v-btn>
        </template>
      </CRUDDialog>
      <!-- follow-up comment dialogs opened by TaxInquiryDialog save -->
      <CRUDDialog
        :baseCrudKey="taxRecordComCrudKey"
        :canSave="true"
        :canCancel="false"
        onlyDialogHeaderName="Create Comment for Owner Info changes"
        @upsertItem="handleTaxRecordComment"
        dialogDynamicWidth="550"
      ><template v-slot:[`editedItem`]="{}">
        <CommentDialog :baseCrudKey="taxRecordComCrudKey" />
        </template>
      </CRUDDialog>
      <CRUDDialog
        :baseCrudKey="taxRecordComForTaxCrudKey"
        :canSave="true"
        :canCancel="false"
        onlyDialogHeaderName="Create Comment for Tax Info changes"
        @upsertItem="handleTaxRecordCommentForTax"
        dialogDynamicWidth="550"
      ><template v-slot:[`editedItem`]="{}">
        <CommentDialog :baseCrudKey="taxRecordComForTaxCrudKey" />
        </template>
      </CRUDDialog>
      <!-- follow-up adjustment dialogs opened by TaxInquiryDialog save -->
      <CRUDDialog
        v-if="destroyOrReRenderTaxRecordAdjComp"
        :baseCrudKey="taxRecordAdjCrudKey"
        :canSave="true"
        :canCancel="false"
        onlyDialogHeaderName="Creating Adjustment Record for Owner Info changes"
        @upsertItem="handleTaxRecordAdjUpdate"
        dialogDynamicWidth="400"
      ><template v-slot:[`editedItem`]="{}">
        <CreateAdjTaxDialog :baseCrudKey="taxRecordAdjCrudKey" />
        </template>
      </CRUDDialog>
      <CRUDDialog
        v-if="destroyOrReRenderTaxRecordTaxInfoAdjComp"
        :baseCrudKey="taxRecordAdjForTaxCrudKey"
        :canSave="true"
        :canCancel="false"
        onlyDialogHeaderName="Creating Adjustment Record for Tax Info changes"
        @upsertItem="handleTaxRecordAdjTaxRollUpdate"
        dialogDynamicWidth="400"
      ><template v-slot:[`editedItem`]="{}">
        <CreateAdjTaxDialog :baseCrudKey="taxRecordAdjForTaxCrudKey" />
        </template>
      </CRUDDialog>

       <!-- <CommonPopUp v-model="showOrHidePopUp"
       :enableFlashTypeMsg="false" :custumWidth="300">
       <template v-slot:customsLabelOrInfo>
        <p style="white-space: pre;">{{ messageText }}</p>
       </template>
        <template v-slot:[`customsButtonsForPopUp`]="{}">
          <v-btn :class="`input-text-size`" text color="blue darken-1"
          @click="openConfirmPopUp('yes')">Yes</v-btn>
          <v-btn :class="`input-text-size`" text color="blue darken-1"
          @click="openConfirmPopUp('no')">No</v-btn>
        </template>
      </CommonPopUp> -->
    </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import { toIsoDate, toShortDate } from '../../../../util/shared/tmc-global';
import {
  amountFormat, amountToNumber, defaultGridLoading, isEmptyObject, manageGridLoading,
  zipDeFormat,
} from '../../../../util/shared/vue-global';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import CRUDDialog from '../../../common/base/crud-2.0/CRUDDialog.vue';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import {
  getChangedFields,
  handleColorChange,
  makeCriteriaStateNullIfEmptyString,
  penaltyCaclCrudListCommonFunc,
  postProcessCommentsTrans,
  taxCommonPostProcessTrans,
  taxFeeCheckWitheEfectiveDate,
  taxFeesPostProcessTrans,
  taxPostProcessFeesList,
} from '../../common-utils/CommonTaxFunctionalities';
import {
  buildMailingAddress,
  commonAdjFuncForTaxrollNOwner,
  exemptManufacturingStatusCode,
  taxCommentTypesObj,
  toOwnerChangesInput,
} from '../../common-utils/tax-common.util';
import { tabs } from '../TaxInquiryUtils/TaxInquiry.utils';
import PaymentCommonFunc from '../../common-utils/PaymentCommonFunc.mixin';
import paymentDialog from '../../payments/paymenteditDialog/paymentDialog.vue';
import AddCommentDialog from '../PickList/addComment.vue';
import PickListAddressChangeDialog from '../PickList/addressChange.vue';
import { PickListHeaders } from '../TaxInquiryUtils/TableHeaders.utils';
// import CommonPopUp from '../../common-utils/CommonPopUp.vue';
import '../../../../assets/style.css';
import UploadFile from '../../../common/UploadFile.vue';
import CommentDialog from '../../TaxCommonComponents/commentDialog.vue';
import CreateAdjTaxDialog from '../../TaxCommonComponents/createAdjTaxDialog.vue';
import TaxInquiryDialog from './TaxInquiryDialog.vue';
import { WIDE_DIALOG_HEIGHT, WIDE_DIALOG_WIDTH } from '../../../../util/shared/dialog-size';

export default {
  mixins: [PaymentCommonFunc],
  name: 'PickListTable',
  props: {
    clickedButton: String,
    selectedPenaltyDate: {
      type: String,
      default: toShortDate(),
    },
  },
  data() {
    return {
      // the tax record dialog's size - shared with the other three hosts of TaxInquiryDialog
      wideDialogWidth: WIDE_DIALOG_WIDTH,
      wideDialogHeight: WIDE_DIALOG_HEIGHT,
      headers: PickListHeaders,
      baseCrudKey: 'pickListTable',
      baseCrudKeyTwo: 'pickListAddCommentsDialog',
      baseCrudKeyThree: 'pickListAddressDialog',
      dialogHeaderName: 'Comments',
      dialogHeaderThree: 'Change Address',
      baseCrudKeyComments: 'taxComments',
      baseCrudKeyAddress: 'addressChange',
      baseCrudKeyFour: 'pickListMakePaymentDialog',
      baseCrudKeyPayment: 'picklistpayment',
      dialogHeaderPayment: 'Payment',
      comDialogCrudKey: 'comDialogForPickList',
      adjDialogCrudKey: 'createAdjTaxDialog',
      destroyOrReRenderAdjComp: false,
      // --- tax record dialog (opens on row double-click) ---
      tabsList: [...tabs],
      taxRecordCrudKey: 'pickListTaxRecordDialog',
      baseCrudKeyForFeeList: 'pickListTaxRecordFeeList',
      taxRecordComCrudKey: 'pickListTaxRecordComDialog',
      taxRecordComForTaxCrudKey: 'pickListTaxRecordComForTaxDialog',
      taxRecordAdjCrudKey: 'pickListTaxRecordAdjDialog',
      taxRecordAdjForTaxCrudKey: 'pickListTaxRecordAdjForTaxDialog',
      destroyOrReRenderTaxRecordAdjComp: false,
      destroyOrReRenderTaxRecordTaxInfoAdjComp: false,
      originalItem: null,
      userName: '',
      taxRecordAttachmentConstants: {
        bucketName: 'taxInquiry',
        program: 'taxInquiry',
        parentObjectType: 'taxInquiryTransaction',
      },
      // showOrHidePopUp: false,
      // messageText: 'Empty pick list?',
      workstation: getWorkstationNumber(),
      gridLoading: defaultGridLoading(),
      activeTransItem: undefined,
      attachmentConstants: {
        bucketName: 'taxPayment',
        program: 'taxPayment',
        parentObjectType: 'taxPayments',
      },
      uploadFileParams: {
        bucketName: 'taxPayment',
        program: 'taxPayment',
        parentObjectType: 'taxPayments',
      },
      uploadFileClickParams: {
        leftClickFlag: false,
        leftClickDef: undefined,
        rightClickFlag: false,
        rightClickDef: undefined,
      },
      enableUploadFile: false,
      addEmailAddressOnly: '',
      addPhone: '',
      totalPickListrecords: 0,
      total: '',
    };
  },
  components: {
    CRUDList,
    AddCommentDialog,
    CRUDDialog,
    PickListAddressChangeDialog,
    paymentDialog,
    UploadFile,
    CommentDialog,
    CreateAdjTaxDialog,
    TaxInquiryDialog,
  },
  computed: {
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
      reasonListDropDown: (state) => state.base.crud.items.reasonListDropDown,
      fortePaymentSuscessFlag: (state) => state.ForteService.fortePaymentSuscessFlag,
      forteIndex: (state) => state.ForteService.forteIndex,
      commentsCategory: (state) => state.base.crud.items.sharedTaxComments,
      taxDistrict: (state) => state.base.crud.items.sharedTaxDistrict,
      statementSettingItem: (state) => state.SystemConfig.statementSettingItem || {},
      feeListBasedInIds: (state) => state.base.crud.items.pickListTaxRecordFeeList,
    }),
    ...mapGetters('base/crud', ['item', 'items', 'criteria', 'isVisible', 'index', 'selectedTab']),
    ...mapGetters(['todaysDate']),
    ...mapGetters('auth/token', ['authUser', 'isTaxAdminAccessible']),
    isTaxRecordDialogVisible() {
      return !!this.isVisible(this.taxRecordCrudKey);
    },
    checkTheUserIsTaxAdmin() {
      return this.isTaxAdminAccessible;
    },
    getUpdatedTabVal: {
      get() {
        return this.selectedTab(this.taxRecordCrudKey);
      },
      set(value) {
        this.setSelectedTab([this.taxRecordCrudKey, value]);
      },
    },
    getdata() {
      return this.item('taxComments');
    },
    getdatas() {
      return this.item(this.baseCrudKeyPayment);
    },
    getTotal() {
      const resItems = this.items(this.baseCrudKey);
      const total = `Total : ${amountFormat(amountToNumber((resItems || []).reduce((amt, item) => amt
       + amountToNumber(item.feesAndPen), 0)))}`;
      const finalObj = {
        total,
      };
      return finalObj;
    },
    footerTotalArray() {
      // Use the reactive computed total from the Vuex store items
      // const resItems = this.items(this.baseCrudKey);
      // const computedTotal = `Total : ${amountFormat(amountToNumber((resItems || []).
      // reduce((amt, item) => amt
      //  + amountToNumber(item.feesAndPen), 0)))}`;
      return [null, null, null, this.total];
    },
    defaultSortBy() {
      return [
        { // this will give us when the records were added to the pick-list
          column: '_id',
          direction: 'asc',
        },
      ];
    },
    getActiveTransID() {
      return (this.activeTransItem || {})._id || 'n/a';
      // return this.activeTransItem && this.activeTransItem._id;
    },
    isNewItem() {
      // return !this.editedItem._id;
      return this.index(this.baseCrudKeyFour) === -1;
    },
    isVisibleProp() {
      const visibleFlag = this.isVisible(this.baseCrudKeyFour);
      if (visibleFlag === undefined) {
        return false;
      }
      return visibleFlag;
    },
  },
  methods: {
    ...mapActions('tax/taxInquiryTabs', [
      'loadPickLists',
      'pickListProfiles',
      'deletePickList',
      'taxPickListTotalRecords',
      'addCommentPickList', 'changeAddressPickList', 'postProccessData', 'deleteAllPickList',
      'pickListUpsertForComments', 'pickListUpsertForAdjustments', 'pickListUpsertForEmail',
      'loadTabsAdjustments']),
    ...mapActions('tax/taxPayment', [
      'upsertTaxPayment',
      'loadTaxPayments',
    ]),
    ...mapActions('tax/taxInquires', [
      'loadTaxInquires',
      'patchTaxInquiryTransaction',
      'callMakeGLobalTaxIdUndefined',
    ]),
    ...mapActions('tax/taxComments', [
      'loadTaxComments',
      'upsertTaxCommentTrans',
    ]),
    ...mapActions('tax/taxRollAdjustments', [
      'upsertTaxRollAdjustments',
    ]),
    ...mapActions('shared/taxLevy', [
      'loadTaxLevy',
    ]),
    ...mapActions('files', [
      'loadAttachedFiles',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria', 'setIsVisible', 'setItem', 'setIndex',
      'setItems', 'setHighlightedId', 'setSelectedTab',
    ]),
    ...mapActions('tax/taxFee', [
      'taxFeesBasedOnIds',
      'loadTaxRollFeesTable',
    ]),
    ...mapMutations('tax/taxInquires', [
      'setTaxRateTaxInquiry',
    ]),
    ...mapMutations('tax/taxInquiryTabs', [
      'setEmptyPickListFlag',
      'setComments',
    ]),
    ...mapMutations('tax/taxPayment', [
      'setSelectedItems',
    ]),
    async getPickLists() {
      this.setEmptyPickListFlag(false);
      manageGridLoading(this, true, 'Searching...');
      this.pickListProfiles({ baseCrudKey: 'pickListProfileNames' });
      const { baseCrudKey } = this;
      const pickListCriteriaMain = this.criteria('pickListCriteria');
      const pickListCriteria = this.criteria(baseCrudKey);
      let criteria = {
        ...pickListCriteria,
      };
      if (pickListCriteriaMain.isItFromProfile !== '' && pickListCriteriaMain.profileName) {
        criteria = {
          ...pickListCriteria,
          profileName: pickListCriteriaMain.profileName,
          halfPayment: pickListCriteriaMain.halfPayment,
        };
      } else {
        const pickListProfileName = localStorage.getItem('pick-list-profile-name');
        if (pickListProfileName) {
          criteria.profileName = pickListProfileName;
          this.setCriteria(['pickListCriteria', { profileName: pickListProfileName }]);
          delete criteria.workstation;
        } else {
          delete criteria.profileName;
          criteria.workstation = Number(this.workstation);
        }
        criteria.halfPayment = pickListCriteriaMain.halfPayment;
      }
      criteria.penaltyDate = pickListCriteriaMain.penaltyDate
        ? toIsoDate(pickListCriteriaMain.penaltyDate) : toIsoDate();
      this.loadPickLists({
        criteria, baseCrudKey, postProcessTransaction: this.taxPostProcessTrans,
      }).finally(async () => {
        await this.getRecordCount(criteria);
        manageGridLoading(this, false);
      });
    },
    async getRecordCount(existCriteria) {
      const todaysPenDate = this.selectedPenaltyDate || toShortDate();
      const criteria = {
        ...existCriteria,
        workstation: Number(this.workstation),
        penaltyDate: todaysPenDate,
      };
      const { totalRecords, total } = await this.taxPickListTotalRecords({ criteria });
      this.totalPickListrecords = (totalRecords || 0);
      this.total = `Total : ${amountFormat(amountToNumber(total || 0))}`;
    },
    async handleCommentForAddressChange(updatedItem) {
      const item = {};
      item.comment = `${updatedItem.fixedComment} ${(updatedItem.comment || '').replace(/\n/g, '')}`;

      if (updatedItem.reasonCode) { // to add reason-desc to the comment
        const reasonCodeWithDesc = (this.reasonListDropDown || [])
          .filter((ft) => ft.value === updatedItem.reasonCode);
        if (reasonCodeWithDesc.length) {
          item.comment = `${item.comment} Per ${reasonCodeWithDesc[0].name}`;
        }
      }
      item.reasonCode = updatedItem.reasonCode || null;
      item.addToLegal = updatedItem.addToLegal || false;
      item.rollToNextYear = updatedItem.rollToNextYear || false;
      item.sendToWebsite = updatedItem.sendToWebsite || false;
      item.ids = updatedItem.ids || [];
      await this.pickListUpsertForComments({ item });
      this.setItem([this.comDialogCrudKey, {}]);

      if (this.taxSettingItem.updateOwnerChangesAdjFlag) {
        const adjItem = {
          certDate: toShortDate(),
        };
        // const adjItem = commonAdjFuncForTaxrollNOwner(returnedVal,
        // this.taxSettingItem.updateOwnerChangesAdjType);
        this.setItem([this.adjDialogCrudKey, adjItem]);
        this.destroyOrReRenderAdjComp = true;
        this.setIsVisible([this.adjDialogCrudKey, true]);
      }
    },
    handleAdjUpdate(updatedItem) {
      const adjItem = {};
      adjItem.certDate = updatedItem.certDate ? toIsoDate(updatedItem.certDate) : toIsoDate();
      adjItem.adjType = this.taxSettingItem.updateOwnerChangesAdjType || '';
      adjItem.certNumber = updatedItem.certNumber || null;
      adjItem.comments = updatedItem.comments || '';
      adjItem.adjDate = toIsoDate();
      const pickListItemsGetter = this.items('pickListTable');
      const taxInquiryIds = (pickListItemsGetter || []).map((ft) => ft.taxInquiryTransaction);
      adjItem.ids = taxInquiryIds;
      this.pickListUpsertForAdjustments({
        item: adjItem,
      }).then(() => {
        this.setItem([this.adjDialogCrudKey, {}]);
        this.destroyOrReRenderAdjComp = false;
      }).catch((err) => console.error(err));
    },
    async handleComment(item) {
      const updatedItem = item;
      const { baseCrudKey } = this;
      // Send the list identity, not the loaded page's _ids - the backend resolves the FULL
      // pick list from this, so the comment reaches every row regardless of page size.
      const pickListCriteriaMain = this.criteria('pickListCriteria');
      if (pickListCriteriaMain.profileName) {
        updatedItem.profileName = pickListCriteriaMain.profileName;
      } else {
        updatedItem.workstation = Number(this.workstation);
      }
      const keysArr = ['wkstNumber', 'name1', 'name2', 'address1', 'address2', 'address3', 'address4', 'city', 'state', 'zip', 'country'];
      // eslint-disable-next-line array-callback-return
      keysArr.map((el) => {
        delete updatedItem[el];
      });
      await this.addCommentPickList({ item: updatedItem, baseCrudKey });
    },
    async handleAddressChage() {
      const { baseCrudKey } = this;
      const updatedItem = this.$refs.addressChange.editedItem;
      const keysArr = ['addToLegal', 'sendToWebsite', 'rollToNextYear', 'comment', 'category'];
      // eslint-disable-next-line array-callback-return
      keysArr.map((el) => {
        delete updatedItem[el];
      });

      // validating if there is any values then allow the next steps
      const checkIfThereIsValues = Object.values(updatedItem).filter((value) => value);
      if ((checkIfThereIsValues || []).length) {
        const onlyTheKeysWithValues = {};
        const pickListCriteriaMain = this.criteria('pickListCriteria');

        const pickListItemsGetter = this.items('pickListTable');
        const pickListIds = (pickListItemsGetter || []).map((ft) => ft._id);
        onlyTheKeysWithValues.wkstNumber = getWorkstationNumber();
        onlyTheKeysWithValues._ids = pickListIds;
        // if there are no value, then set it to empty string
        onlyTheKeysWithValues.name1 = updatedItem.name1 || '';
        onlyTheKeysWithValues.name2 = updatedItem.name2 || '';
        onlyTheKeysWithValues.address1 = updatedItem.address1 || '';
        onlyTheKeysWithValues.address2 = updatedItem.address2 || '';
        onlyTheKeysWithValues.address3 = updatedItem.address3 || '';
        onlyTheKeysWithValues.address4 = updatedItem.address4 || '';
        onlyTheKeysWithValues.city = updatedItem.city || '';
        onlyTheKeysWithValues.state = updatedItem.state || '';
        onlyTheKeysWithValues.zip = zipDeFormat(updatedItem.zip);
        onlyTheKeysWithValues.country = updatedItem.country || '';
        onlyTheKeysWithValues.profileName = pickListCriteriaMain.profileName || '';
        const commentItem = await this.changeAddressPickList(
          { item: onlyTheKeysWithValues, baseCrudKey },
        );
        commentItem.fixedComment = commentItem.comment;
        commentItem.comment = '';
        this.$emit('refetchTaxInquiryData');
        // this.setItem([this.comDialogCrudKey, commentItem]);
        // this.setIsVisible([this.comDialogCrudKey, true]);
      }
    },
    async handleAddEmailAddress() {
      const pickListItemsGetter = this.items('pickListTable') || [];
      const pickListIds = pickListItemsGetter.map((ft) => ft._id);
      // Nothing to do (the dialog still calls this even with empty inputs / list).
      if (!pickListIds.length || (!this.addEmailAddressOnly && !this.addPhone)) {
        return;
      }
      // Blast-radius confirmation: this writes the phone/email to EVERY record currently
      // in the pick list. Show the count + the tax years affected so it can't surprise.
      const years = [...new Set(pickListItemsGetter.map((ft) => ft.taxYear))].sort();
      const yearLabel = years.length > 1
        ? `tax years ${years[0]}–${years[years.length - 1]}`
        : `tax year ${years[0]}`;
      const proceed = window.confirm(
        `Apply this phone/email to all ${pickListIds.length} record(s) in the pick list (${yearLabel})?`,
      );
      if (!proceed) return;
      const item = {
        _ids: pickListIds,
        emailAddress: this.addEmailAddressOnly,
        phoneNumber: this.addPhone,
      };
      await this.pickListUpsertForEmail({ item });
      // Clear BOTH fields so a stale value can't be re-applied on the next use.
      this.addEmailAddressOnly = '';
      this.addPhone = '';
      // Reload the grid so the updated phone/email reflect without a page refresh.
      await this.getPickLists();
    },
    async taxPostProcessTrans(items) {
      const todaysPenDate = this.selectedPenaltyDate || toShortDate();
      const returnData = penaltyCaclCrudListCommonFunc(
        todaysPenDate, items, this.taxSettingItem, [], 'fromPickList',
      );
      return returnData;
    },

    // ----- tax record dialog (double-click a pick list row) -----
    // Pick list rows are partial pickList records, so fetch the full tax-inquiry
    // transaction by taxYear+taxId, load its sub-data, then open TaxInquiryDialog.
    async handleTaxRecordDoubleClick(row) {
      if (!row || !row.taxYear || !row.taxId) return;
      // CRUDList.handleEditItem flips the grid's own visible flag on double-click;
      // clear it (no dialog is bound to the grid key) so grid arrow-key nav still works.
      this.setIsVisible([this.baseCrudKey, false]);
      this.resetTabsList();
      const criteria = { taxYear: row.taxYear, taxId: row.taxId };
      const records = await this.loadTaxInquires({
        criteria,
        baseCrudKey: this.taxRecordCrudKey,
        postProcessTrans: this.taxRecordPostProcessTransWithFees,
      });
      const fullRecord = (records || [])[0];
      if (!fullRecord) {
        this.$store.dispatch('flashError', 'Tax record not found for this pick list row.', { root: true });
        return;
      }
      this.originalItem = JSON.parse(JSON.stringify(fullRecord));
      this.setItem([this.taxRecordCrudKey, fullRecord]);
      this.setIndex([this.taxRecordCrudKey, 0]);
      const doesItHasMobileListOrNot = [];
      if (Number(fullRecord.mobileHome || 0) > 0) {
        doesItHasMobileListOrNot.push(doesItHasMobileListOrNot);
      }
      const returnedList = handleColorChange('Mobile', doesItHasMobileListOrNot, tabs);
      this.tabsList = [...returnedList];
      this.loadTaxPayments({ criteria, baseCrudKey: 'GeneralDetailsPayments' }); // for taxinfo-payment
      this.loadTaxRollFeesTable({ criteria, baseCrudKey: 'taxRollFeesTable', postProcessTrans: this.taxRecordFeesPreProcessTrans });
      this.loadTaxComments({ criteria, baseCrudKey: 'commentsTransactionList', postProcessTrans: this.taxRecordCommentsPostProcessTrans }).then(() => {
        this.setDefaultComments();
      });
      this.setItems(['historyTransactionListBaseCrudKey', []]); // to reset the items
      if (fullRecord.propertyOrParcelId) {
        this.loadTaxInquires({
          criteria: { propertyOrParcelId: fullRecord.propertyOrParcelId },
          baseCrudKey: 'historyTransactionListBaseCrudKey',
          postProcessTrans: this.taxRecordPostProcessTrans,
        });
      }
      const returnedAdjArr = await this.loadTabsAdjustments({ criteria, baseCrudKey: 'TaxRollAdjustments' });
      const returnedAdjList = handleColorChange('Adjustments', returnedAdjArr, tabs);
      this.tabsList = [...returnedAdjList];
      let taxLevyTotal = null;
      if (fullRecord.schoolDistrict && this.taxDistrict) {
        const filDist = this.taxDistrict.filter((ft) => ft.districtCode === fullRecord.schoolDistrict);
        if (filDist.length) {
          const critLevy = { taxDistrict: filDist[0]._id, taxYear: fullRecord.taxYear };
          const taxLevyData = await this.loadTaxLevy({ criteria: critLevy });
          if (taxLevyData.length) {
            taxLevyTotal = taxLevyData.reduce((acc, item) => acc + amountToNumber(item.mills || 0), 0);
          }
        }
      }
      this.setTaxRateTaxInquiry(taxLevyTotal);
      this.setIsVisible([this.taxRecordCrudKey, true]);
    },
    closeTaxRecordDialog() {
      this.getUpdatedTabVal = 0;
      this.setIsVisible([this.taxRecordCrudKey, false]);
      this.originalItem = null;
    },
    resetTabsList() {
      const mappedArr = (tabs || []).map((ft) => {
        const item = ft;
        item.color = '';
        return item;
      });
      this.tabsList = mappedArr; // reseting tabs
    },
    checkFormValidOrNot(whatColor = '') {
      const mappedArr = (tabs || []).map((ft) => {
        const item = ft;
        if (item.id === 0) item.color = whatColor;
        if (item.id === 1) item.color = whatColor;
        return item;
      });
      this.tabsList = mappedArr;
    },
    setDefaultComments() {
      this.$nextTick(() => {
        this.setComments([]);
      });
    },
    areTheyAreForms() {
      // to check if the form is in adjustment or comment
      if (this.getUpdatedTabVal === 2 || this.getUpdatedTabVal === 3
      || this.getUpdatedTabVal === 5 || this.getUpdatedTabVal === 6) return true;
      return false;
    },
    taxRecordFeesPreProcessTrans(items) {
      return taxFeesPostProcessTrans(items);
    },
    taxRecordCommentsPostProcessTrans(items) {
      return postProcessCommentsTrans(items, this.commentsCategory);
    },
    taxRecordPostProcessTrans(items) {
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      return taxCommonPostProcessTrans(
        items, this.todaysDate, this.taxSettingItem,
        this.selectedPenaltyDate || toShortDate(), formatPidPositions, {},
      );
    },
    async taxRecordPostProcessTransWithFees(items) {
      // to filter only the still due tax records
      const filterUnPaidTaxes = (items || []).filter((ft) => amountToNumber(ft.totalDue) > 0);
      let feesData = [];
      if (filterUnPaidTaxes.length) {
        const ids = filterUnPaidTaxes.map((ft) => ft._id);
        feesData = await this.taxFeesBasedOnIds({
          criteria: { ids },
          baseCrudKey: this.baseCrudKeyForFeeList,
          postProcessTrans: taxPostProcessFeesList,
        });
      }
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      return taxCommonPostProcessTrans(
        items, this.todaysDate, this.taxSettingItem,
        this.selectedPenaltyDate || toShortDate(), formatPidPositions, {}, feesData,
      );
    },
    async upsertRecords(isFromTaxInquiryDialog = false, overrideValidate = false) {
      const validate = this.$refs.taxRecordDialog.validateForm();
      this.checkFormValidOrNot('red');
      // if the validate is false and the overrideValidate is false, then return
      if (!overrideValidate) {
        if (!validate) return;
      }
      const baseCrudKey = this.taxRecordCrudKey;
      const item = this.item(baseCrudKey);
      const updatedItem = { ...this.item(baseCrudKey) };
      const getAllFeeTotal = taxFeeCheckWitheEfectiveDate(this.items('taxRollFeesTable') || [], this.todaysDate);
      updatedItem.userName = this.userName || this.authUser;
      updatedItem.wkstNumber = getWorkstationNumber();
      updatedItem.schoolDistrict = updatedItem.taxDistrict;
      updatedItem.zip = zipDeFormat(updatedItem.zip);
      updatedItem.propertyOrParcelId = (updatedItem.propertyOrParcelId || '').replace(/-/g, '');
      updatedItem.penaltyStartDate = updatedItem.penaltyStartDate
        ? toIsoDate(updatedItem.penaltyStartDate) : updatedItem.penaltyStartDate;
      updatedItem.mhDecalDate = updatedItem.mhDecalDate
        ? toIsoDate(updatedItem.mhDecalDate) : updatedItem.mhDecalDate;
      const isExemptManufacturing = (updatedItem.statusCode || [])
        .includes(exemptManufacturingStatusCode);
      updatedItem.totalFee = isExemptManufacturing ? 0 : getAllFeeTotal;
      delete updatedItem.taxDistrict;
      delete updatedItem.hasFiles;
      delete updatedItem.getPenRateWithMonths;
      delete updatedItem.penaltyAmount;
      delete updatedItem.penaltyDateValue;
      delete updatedItem.feesAndPen;
      delete updatedItem.totalDueIsNegative;
      Object.keys(updatedItem).forEach((key) => {
        if (key.startsWith('#')) delete updatedItem[key];
      });
      // Compute only the changed fields for patch
      const changedKeys = this.originalItem
        ? new Set(Object.keys(getChangedFields(this.originalItem, item)))
        : null;
      let patchPayload;
      if (changedKeys) {
        patchPayload = { _id: updatedItem._id };
        patchPayload.userName = updatedItem.userName;
        patchPayload.wkstNumber = updatedItem.wkstNumber;
        Object.keys(updatedItem).forEach((key) => {
          if (changedKeys.has(key)) {
            patchPayload[key] = updatedItem[key];
          }
        });
        // taxDistrict is renamed to schoolDistrict in the transformation
        if (changedKeys.has('taxDistrict')) {
          patchPayload.schoolDistrict = updatedItem.schoolDistrict;
        }
      } else {
        patchPayload = updatedItem;
      }
      const returnRes = makeCriteriaStateNullIfEmptyString(patchPayload);
      const returnedVal = await this.patchTaxInquiryTransaction({
        item: returnRes,
        baseCrudKey,
        postProcessTrans: this.taxRecordPostProcessTrans,
      });
      // reflect any edits (name / fees) back onto the pick list grid row
      this.getPickLists();

      // this is used to create adjustment and comment
      if (returnedVal.commentForTaxInfoChanges || returnedVal.commentOnlyForOwner) {
        if (returnedVal.commentForTaxInfoChanges) { // tax-info changes
          const commentItem = {
            taxYear: returnedVal.taxYear,
            taxId: returnedVal.taxId,
            beforeChange: returnedVal.beforeChangeForTax,
            afterChange: returnedVal.afterChangeForTax,
            category: taxCommentTypesObj.taxRecordCode,
            taxInquiryTransaction: returnedVal._id,
          };
          commentItem.fixedComment = returnedVal.commentForTaxInfoChanges;
          commentItem.comment = '';
          commentItem.createdAt = returnedVal.commentCreatedDate || toIsoDate();
          if (this.checkTheUserIsTaxAdmin) {
            this.handleTaxRecordCommentForTax(commentItem);
          } else {
            this.setItem([this.taxRecordComForTaxCrudKey, commentItem]);
            this.setIsVisible([this.taxRecordComForTaxCrudKey, true]);
          }
          if (this.taxSettingItem.updateTaxrollChangesAdjFlag) {
            const adjItem = commonAdjFuncForTaxrollNOwner(returnedVal,
              this.taxSettingItem.updateTaxrollChangesAdjType);
            this.setItem([this.taxRecordAdjForTaxCrudKey, adjItem]);
            this.destroyOrReRenderTaxRecordTaxInfoAdjComp = true;
            this.setIsVisible([this.taxRecordAdjForTaxCrudKey, true]);
          }
        }
        if (returnedVal.commentOnlyForOwner) { // owner info changes
          const commentItem = {
            taxYear: returnedVal.taxYear,
            taxId: returnedVal.taxId,
            beforeChange: buildMailingAddress(this.originalItem),
            afterChange: buildMailingAddress(returnedVal),
            ownerChanges: toOwnerChangesInput(returnedVal.ownerChanges),
            category: taxCommentTypesObj.ownerInfoCode,
            taxInquiryTransaction: returnedVal._id,
          };
          commentItem.fixedComment = returnedVal.commentOnlyForOwner;
          commentItem.comment = '';
          commentItem.createdAt = returnedVal.commentCreatedDate || toIsoDate();
          this.setItem([this.taxRecordComCrudKey, commentItem]);
          this.setIsVisible([this.taxRecordComCrudKey, true]);
          if (this.taxSettingItem.updateOwnerChangesAdjFlag) {
            const adjItem = commonAdjFuncForTaxrollNOwner(returnedVal,
              this.taxSettingItem.updateOwnerChangesAdjType);
            this.setItem([this.taxRecordAdjCrudKey, adjItem]);
            this.destroyOrReRenderTaxRecordAdjComp = true;
            this.setIsVisible([this.taxRecordAdjCrudKey, true]);
          }
        }
      }
      if (isFromTaxInquiryDialog) {
        const criteria = { taxYear: item.taxYear, taxId: item.taxId };
        this.loadTaxComments({ criteria, baseCrudKey: 'commentsTransactionList', postProcessTrans: this.taxRecordCommentsPostProcessTrans }).then(() => {
          this.setDefaultComments();
        });
      }
      if (isExemptManufacturing) {
        const exemptItem = { ...this.item(baseCrudKey) };
        exemptItem.feesAndPen = 0;
        exemptItem.getPenRateWithMonths = 0;
        exemptItem.penaltyAmount = 0;
        exemptItem.totalFee = 0;
        this.setItem([baseCrudKey, exemptItem]);
      }
      this.setIsVisible(['createOmit', false]); // to close omit dialog
      if (!isFromTaxInquiryDialog) this.closeTaxRecordDialog();
      this.checkFormValidOrNot('');
      await this.callMakeGLobalTaxIdUndefined({ type: 'omittedProperties' });
    },
    async handleTaxRecordComment(updatedItem) {
      const item = updatedItem;
      const comment = `${item.fixedComment} ${(updatedItem.comment || '').replace(/\n/g, '')}`;
      item.comment = (comment || '').replace('Wkst-undefined', `wkst-${this.workstation}`);
      item.userName = this.userName || this.authUser;

      if (item.reasonCode) { // to add reason-desc to the comment
        const reasonCodeWithDesc = (this.reasonListDropDown || [])
          .filter((ft) => ft.value === item.reasonCode);
        if (reasonCodeWithDesc.length) {
          item.comment = `${item.comment} Per ${reasonCodeWithDesc[0].name}`;
        }
      }
      delete item.fixedComment;
      await this.upsertTaxCommentTrans({
        item,
        baseCrudKey: this.taxRecordComCrudKey,
      }).then(() => {
        this.setItem([this.taxRecordComCrudKey, {}]);
      });
    },
    async handleTaxRecordCommentForTax(updatedItem) {
      const item = updatedItem;
      item.comment = `${item.fixedComment} ${(updatedItem.comment || '').replace(/\n/g, '')}`;
      item.userName = this.userName || this.authUser;

      if (item.reasonCode) { // to add reason-desc to the comment
        const reasonCodeWithDesc = (this.reasonListDropDown || [])
          .filter((ft) => ft.value === item.reasonCode);
        if (reasonCodeWithDesc.length) {
          item.comment = `${item.comment} Per ${reasonCodeWithDesc[0].name}`;
        }
      }
      delete item.fixedComment;
      await this.upsertTaxCommentTrans({
        item,
        baseCrudKey: this.taxRecordComForTaxCrudKey,
      }).then(() => {
        this.setItem([this.taxRecordComForTaxCrudKey, {}]);
      });
    },
    handleTaxRecordAdjUpdate(updatedItem) {
      const adjItem = updatedItem;
      adjItem.certDate = updatedItem.certDate ? toIsoDate(updatedItem.certDate) : toIsoDate();
      adjItem.adjDate = toIsoDate();
      adjItem.adjOrUpd = 'UPDATE';
      this.upsertTaxRollAdjustments({
        item: adjItem,
      }).then(() => {
        this.setItem([this.taxRecordAdjCrudKey, {}]);
        this.destroyOrReRenderTaxRecordAdjComp = false;
      }).catch((err) => console.error(err));
    },
    handleTaxRecordAdjTaxRollUpdate(updatedItem) {
      const adjItem = updatedItem;
      adjItem.certDate = updatedItem.certDate ? toIsoDate(updatedItem.certDate) : toIsoDate();
      adjItem.adjDate = toIsoDate();
      adjItem.adjOrUpd = 'UPDATE';
      this.upsertTaxRollAdjustments({
        item: adjItem,
      }).then(() => {
        this.setItem([this.taxRecordAdjForTaxCrudKey, {}]);
        this.destroyOrReRenderTaxRecordTaxInfoAdjComp = false;
      }).catch((err) => console.error(err));
    },

    // openConfirmPopUp(fromWhere) {
    //   if (fromWhere === 'no') this.showOrHidePopUp = false;
    //   else if (fromWhere === 'yes') {
    //     this.showOrHidePopUp = false;
    //     const item = {
    //       workstation: Number(this.workstation),
    //     };
    //     this.deleteAllPickList({ item, baseCrudKey: this.baseCrudKey });
    //   }
    // },
    postProccessData(items) {
      const updatedItems = [];
      for (let i = 0; i < items.length; i += 1) {
        const item = { ...items[i] };
        if (item.paymentDetails && item.paymentDetails.length > 0) {
          if (item.paymentDetails[0].paymentType === 'CHECK') {
            item.checkAmount = item.paymentDetails[0].amount;
          }
          if (item.paymentDetails[0].paymentType === 'CASH') {
            item.cashAmount = item.paymentDetails[0].amount;
          }
          if (item.paymentDetails[0].paymentType === 'EFT') {
            item.otherAmount = item.paymentDetails[0].amount;
          }
        } else {
          item.paymentDetails = [];
        }
        if (item.taxDetails && item.taxDetails.length > 0) {
          let totalSum = 0;
          let voidValue;

          for (const taxDetail of item.taxDetails) {
            totalSum += taxDetail.total;
            voidValue = taxDetail.void;
          }

          item.total = totalSum;
          item.void = voidValue;
        } else {
          item.taxDetails = [];
        }

        updatedItems.push(item);
      }
      return updatedItems;
    },
    async onUpsertCall(isItFromSaveNPrint) {
      // Ignore a re-click / double-click while the first save is still running - see
      // isDuplicateSaveClick (two no-paymentNumber calls create two payment records).
      if (this.isDuplicateSaveClick()) return;
      const item = this.item(this.baseCrudKeyFour);
      await this.upsertTransaction(item, false, isItFromSaveNPrint);
      this.$emit('upsertFuncCall');
    },
    async upsertPayments(item) {
      // Enter-key save. Guarded like the buttons: pressing Enter while a save is already
      // running is a second submission and would create a second payment record.
      if (this.isDuplicateSaveClick()) return;
      await this.upsertTransaction(item, false);
    },
    async imagesLeftClick(leftClick) {
      if (this.isNewItem) {
        this.uploadFileClickParams.leftClickFlag = true;
        this.uploadFileClickParams.leftClickDef = leftClick;
        // await this.upsrtTransaction(this.editedItem, false);
        await this.preUpsertTransaction(this.item(this.baseCrudKeyFour), true, false, false);
      } else {
        leftClick();
      }
    },
    async imagesRightClick(rightClick) {
      if (this.isNewItem) {
        this.uploadFileClickParams.rightClickFlag = true;
        this.uploadFileClickParams.rightClickDef = rightClick;
        // this.setIsVisible([this.baseCrudKeyFour, true]);
        await this.preUpsertTransaction(this.item(this.baseCrudKeyFour), true, false, false);
        // this.setIsVisible([this.baseCrudKeyFour, true]);
        rightClick();
      }
    },

    // activateTransaction(val) {
    //   this.activeTransItem = val;
    // },
    loadFiles() {
      this.loadAttachedFiles({
        bucketName: this.attachmentConstants.bucketName,
        program: this.attachmentConstants.program,
        parentObjectType: this.attachmentConstants.parentObjectType,
        parentObjectId: (this.activeTransItem || {})._id || 'n/a',
      });
    },
    settingFields(res) {
      this.activeTransItem = res;
      this.setItem([this.baseCrudKeyFour, res]);
      this.setIndex([this.baseCrudKeyFour, 0]);
    },
    updateActiveTransItem(res) {
      if (this.uploadFileClickParams.leftClickFlag) {
        this.settingFields(res);
        this.$nextTick(() => {
          this.imagesLeftClick(this.uploadFileClickParams.leftClickDef);
          this.uploadFileClickParams.leftClickFlag = false;
          this.uploadFileClickParams.leftClickDef = undefined;
        });
      } else if (this.uploadFileClickParams.rightClickFlag) {
        this.settingFields(res);
        this.$nextTick(() => {
          this.imagesRightClick(this.uploadFileClickParams.rightClickDef);
          this.uploadFileClickParams.rightClickFlag = false;
          this.uploadFileClickParams.rightClickDef = undefined;
        });
      }
      return false;
    },
    // Removed redundant upsrtTransaction method as it was causing issues
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        // this.selectedItems = [];
      });
    },
    async preUpsertTransaction(item, avoidUpdatingCrudList, isItFromSaveNPrint, shouldCloseDialog) {
      // if (this.isValidFormProp(this.baseCrudKey).value) {
      this.enableUploadFile = true;
      // eslint-disable-next-line max-len
      const response = await this.upsertTransaction(item, avoidUpdatingCrudList, isItFromSaveNPrint, shouldCloseDialog);
      this.getPickLists(); // to reload the pick list table
      this.enableUploadFile = false;
      if (!isEmptyObject(response)) {
        this.updateActiveTransItem(response);
      }
      this.setDefaultSelectedItems();
      // this.callTheBroadBand();
      // return response;
      // }
      // return [];
    },
    applySuccessfulFortePayment() {
      const savedItem = this.item(this.baseCrudKeyFour);
      if (!savedItem || !savedItem.paymentDetails) return;
      const updatedPaymentDetails = savedItem.paymentDetails.map((paymentDetail, index) => {
        if (paymentDetail.paymentType === 'CREDIT' && index === this.forteIndex) {
          return { ...paymentDetail, ccProcessed: true };
        }
        return paymentDetail;
      });
      const updatedItem = {
        ...savedItem,
        paymentDetails: updatedPaymentDetails,
      };
      // Persist to the store BEFORE saving (mirrors the Payrix watcher) so the
      // duplicate-payment guard in postUpsertTransaction can carry the assigned
      // paymentNumber back onto the store-bound object. Without this, a re-fire of this
      // Forte success watcher reads the still-null store item and saves a fresh clone
      // -> duplicate payment.
      this.setItem([this.baseCrudKeyFour, updatedItem]);
      this.preUpsertTransaction(updatedItem, true, false);
    },
    // saveDetails(item) {
    //   this.upsertTransaction(item);
    //   this.showOrHidePopUp = true;
    // },

  },
  watch: {
    isVisibleProp(newVal) {
      if (newVal) {
        this.$nextTick(() => { this.loadFiles(); });
      } else {
        // this.activeTransItem = undefined;
      }
    },
    fortePaymentSuscessFlag(newVal) {
      if (newVal && this.isVisibleProp) {
        this.applySuccessfulFortePayment();
      }
    },
  },
};
</script>
